import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link } from "react-router-dom";
import "react-form-wizard-component/dist/style.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { Dropdown } from "primereact/dropdown";
import {
  AddOrgEmpLeaves,
  getLeaveMasterType,
  PostLeaveAdjustment,
} from "../leaveService";
import { TostMsg } from "../../../../App";
import { GetMasterSystemAlert } from "../../../../Services/Global-Services/GlobalServices";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch } from "react-redux";
import { setLeaveRequestData } from "../../../../Services/Redux/DataTransferToAnother";
import LeaveNavBarItems from "../CommonComponents/LeaveNavBarItems";
const ComponentLoader = React.lazy(() =>
  import("../../../../Shared/Sidebar/ComponentLoader")
);
function LeaveAdjustment() {
  // var AddMore = [0, 1, 2];
  const dispatch = useDispatch();
  const [AddMore, setAddMore] = React.useState(0);
  const [Isloading, setIsloading] = useState(false);
  const [employeDetails, setEmployeeDetails] = useState([]);
  const [leaveType, setLeaveType] = useState([]);
  const [leaveStatus, setLeaveStatus] = useState([
    { Id: 1, LeaveStatus: "Credit " },
    { Id: 2, LeaveStatus: "Debit " },
  ]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const history = useHistory();
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [howItWorkHeader, setHowItWorkHeader] = useState([]);
  const [howItWorkText, setHowItWorkText] = useState([]);

  useEffect(() => {
    GetMasterSystemAlertList();
    // GetMasterSystemAlert("Leave_Adjustment_Text", 0);
    getLeaveType();
    // fetchEmployeeIdData();
  }, []);

  var BasicInfo = false;
  let EmplyeeInfo = false;
  let PersonalInfo = false;

  const renderComponent = () => {
    if (AddMore == 0) {
      BasicInfo = true;
      EmplyeeInfo = false;
      PersonalInfo = false;
    } else if (AddMore == 1) {
      BasicInfo = false;
      EmplyeeInfo = true;
      PersonalInfo = false;
    } else {
      BasicInfo = false;
      EmplyeeInfo = false;
      PersonalInfo = true;
    }
  };

  //For get the employee data.
  async function fetchEmployeeIdData() {
    setIsloading(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 100000000,
      EmployeeId: 0,//userDetails?.EmpId,
      IsSuggestedOnly: 0,
    };

    try {
      let employeesList = await getEmployeeList(params);
      let employeeValidateList = [];
      employeeValidateList = employeesList.Data?.filter(
        (el) => el?.EmpId != userDetails?.EmpId
      );
      await setEmployeeDetails(employeeValidateList);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getLeaveType() {
    // setIsloading(true);
    const params = {
      OrgId: userDetails?.OrgId,
    };
    try {
      const data = await getLeaveMasterType(params);
      let projectDetailData = await data;
      setLeaveType(projectDetailData?.Data);
      // setIsloading(false);
    } catch {
      // setIsloading(false);
    }
  }

  const requestLeaveValidation = Yup.object().shape({
    EmpId: Yup.string().required("Team Member is required."),
    LeaveCount: Yup.string().required("Leave count is required."),
    leaveTypeId: Yup.string().required("Leave type is required."),
    comment: Yup.string().required("Comment is required."),
    CreditOrDebit: Yup.string().required("Leave status is required."),
  });

  const requestLeaveForm = useFormik({
    initialValues: {
      EmpId: "",
      LeaveCount: "",
      leaveTypeId: "",
      comment: "",
      CreditOrDebit: "",
    },
    validationSchema: requestLeaveValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      let CreditDebit;
      if (data?.CreditOrDebit == 1) {
        CreditDebit = "CR";
      } else {
        CreditDebit = "DR";
      }

      const leaveRequestParams = {
        LoggedInEmpId: userDetails?.EmpId,
        OrgId: userDetails?.OrgId,
        LeaveType: Number(data?.leaveTypeId),
        LeaveCount: data?.LeaveCount,
        EmpId: Number(data?.EmpId),
        Comment: data?.comment,
        CreditOrDebit: CreditDebit,
      };
      try {
        if (isLeaveCount == false) {
          const applyLeaveResponse = await PostLeaveAdjustment(
            leaveRequestParams
          );
          if (applyLeaveResponse?.StatusCode === 2000) {
            setIsloading(false);
            GetMasterSystemAlertList("Leave_Adjust", 0);
            // toster.current.success("Adjustment added successfully.");
            requestLeaveForm.resetForm();
            dispatch(setLeaveRequestData(leaveRequestParams));
            history.push("/MyLedger");
          } else {
            const message = applyLeaveResponse?.Message;
            toster.current.warn(message);
            setIsloading(false);
          }
          setisLeaveCount(false);
        } else {
          setisLeaveCount(true);
        }
      } catch (error) {
        setIsloading(false);
        toster.current.error("You already have sufficient leaves.");
      } finally {
        setIsloading(false);
      }
    },
  });

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setMasterSystemAlertData(msg?.Desc);
      }

      if (msg?.Name == "OrGenie_HowItWorks_Header") {
        setHowItWorkHeader(msg?.Desc);
      }
      if (msg?.Name == "Leave_Adjustment_Text") {
        setHowItWorkText(msg?.Desc);
      }
    });
  }, []);

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option?.FullName}
          src={option?.ProfileImage}
          width="32"
        />
        <span>
          {option?.FullName}
          {option?.CurrentDesignation?.length > 0 && ","}
        </span>
        {/* <span>
          {option?.UserName}
          {option?.CurrentDesignation?.length > 0 && ","}
        </span> */}
        <span>{option?.CurrentDesignation}</span>
      </div>
    );
  };

  const [isLeaveCount, setisLeaveCount] = useState(false);
  useEffect(() => {
    // let CheckDecimal
    let LeaveDecimalValue = requestLeaveForm.values.LeaveCount;
    // let FinalValue = LeaveDecimalValue?.slice(-2);
    let decimalValue = LeaveDecimalValue.toString().split(".")[1];

    if (!Number.isInteger(LeaveDecimalValue)) {
      if (decimalValue?.length >= 2) {
        setisLeaveCount(true);
      } else {
        decimalValue = ".5";
        setisLeaveCount(false);
      }
    } else {
      setisLeaveCount(false);
    }

    // if (LeaveDecimalValue?.length == 3) {
    //   // if (FinalValue == ".5") {
    //   //   setisLeaveCount(false);
    //   // } else {
    //   //   setisLeaveCount(true);
    //   // }
    // } else if (LeaveDecimalValue?.length == 4) {
    //   // if (FinalValue == ".5") {
    //   //   setisLeaveCount(false);
    //   // } else {
    //   //   setisLeaveCount(true);
    //   // }
    // } else {
    //   setisLeaveCount(false);
    // }
  }, [requestLeaveForm.values.LeaveCount]);

  return (
    <div>
      {renderComponent()}
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid position-relation">
        <div className="row">
          <div className="">
            <div className="form-head  mb-3">
              <div className="row">
                <div className="col-lg-5">
                  <div className="">
                    <h2 className="font-w600 mb-0">
                      <img src="images/new-emp.png" />
                      Leave Adjustment
                    </h2>
                    <p className="text-light">
                      Grant or adjust leaves for team members to correct or
                      update records.
                    </p>
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="rightside-tabs">
                    <LeaveNavBarItems />
                  </div>
                </div>
              </div>

              {AddMore != 0 && (
                <div
                  className="rightside-tabs"
                  onClick={() => setAddMore(AddMore - 1) % 3}
                >
                  {/* <Link to="Dashboard"> */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    className="bi bi-arrow-left-short"
                    viewBox="0 0
 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.7
 07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
 .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                    ></path>
                  </svg>
                  {/* </Link> */}
                </div>
              )}
            </div>
            {BasicInfo && (
              <div className="formfill-addemployee">
                <div className="row justify-content-center">
                  <div className="col-xl-8">
                    <div className="supp-req">
                      <div className="addcourseform">
                        <form onSubmit={requestLeaveForm.handleSubmit}>
                          <span className="tagtitle">Leave Details </span>
                          <div className="row mt-3">
                            <div className="mb-4 col-md-12">
                              <div className="innerform-grp">
                                <label className="form-label">
                                  Team Member
                                </label>
                                <Dropdown
                                  value={requestLeaveForm.values.EmpId}
                                  onClick={() => fetchEmployeeIdData()}
                                  // onChange={(e) => { setSelectedEmployees(e.value); requestLeaveForm.handleChange(e) }
                                  // }
                                  onChange={requestLeaveForm.handleChange}
                                  options={employeDetails}
                                  filter={true}
                                  optionLabel="FullName"
                                  optionValue="EmpId"
                                  placeholder="Choose"
                                  maxSelectedLabels={1}
                                  itemTemplate={employeeOptionTemplate}
                                  name="EmpId"
                                  className={
                                    "w-100 md:w-20rem p-0 h-40 line-height-40 custom-multiselect" +
                                    (requestLeaveForm.errors.EmpId &&
                                      requestLeaveForm.touched.EmpId
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                              </div>
                              <div className="invalid-feedback">
                                {requestLeaveForm.errors.EmpId &&
                                  requestLeaveForm.touched.EmpId
                                  ? requestLeaveForm.errors.EmpId
                                  : null}
                              </div>
                            </div>
                            {requestLeaveForm.values.EmpId && (
                              <div className="mb-4 col-md-12">
                                <div className="innerform-grp">
                                  <label className="form-label">
                                    Adjustment Type{" "}
                                  </label>
                                  <div className="cover-form">
                                    <Dropdown
                                      onChange={requestLeaveForm.handleChange}
                                      name="leaveTypeId"
                                      value={
                                        requestLeaveForm.values.leaveTypeId
                                      }
                                      options={leaveType}
                                      optionLabel="LeaveTypes"
                                      optionValue="LeaveTypeId"
                                      placeholder="Choose"
                                      checkmark={true}
                                      highlightOnSelect={false}
                                      className={
                                        "w-100 md:w-20rem p-0 h-40 line-height-40 custom-multiselect"
                                      }
                                    />
                                  </div>
                                  <div className="invalid-feedback">
                                    {requestLeaveForm.errors.leaveTypeId &&
                                      requestLeaveForm.touched.leaveTypeId
                                      ? requestLeaveForm.errors.leaveTypeId
                                      : null}
                                  </div>
                                </div>
                              </div>
                            )}
                            {requestLeaveForm.values.leaveTypeId && (
                              <div className="mb-4 col-md-6">
                                <div className="innerform-grp">
                                  <label className="form-label">
                                    Leave Status
                                  </label>
                                  <div className="cover-form">
                                    <Dropdown
                                      onChange={requestLeaveForm.handleChange}
                                      name="CreditOrDebit"
                                      value={
                                        requestLeaveForm.values.CreditOrDebit
                                      }
                                      options={leaveStatus}
                                      optionLabel="LeaveStatus"
                                      optionValue="Id"
                                      placeholder="Choose"
                                      checkmark={true}
                                      highlightOnSelect={false}
                                      className={
                                        "w-100 md:w-20rem p-0 h-40 line-height-40 custom-multiselect"
                                      }
                                    />
                                  </div>
                                  <div className="invalid-feedback">
                                    {requestLeaveForm.errors.CreditOrDebit &&
                                      requestLeaveForm.touched.CreditOrDebit
                                      ? requestLeaveForm.errors.CreditOrDebit
                                      : null}
                                  </div>
                                </div>
                              </div>
                            )}

                            {requestLeaveForm.values.CreditOrDebit && (
                              <div className="mb-4 col-md-6">
                                <div className="innerform-grp">
                                  <label className="form-label">
                                    Leave Count
                                  </label>
                                  <div className="cover-form d-block w-100">
                                    <input
                                      type="number"
                                      min="0"
                                      max="50"
                                      oninput="validity.valid||(value='');"
                                      step="0.5"
                                      name="LeaveCount"
                                      onWheel={(e) => e.target.blur()}
                                      className={
                                        "form-control" +
                                        (requestLeaveForm.errors.LeaveCount &&
                                          requestLeaveForm.touched.LeaveCount
                                          ? " is-invalid"
                                          : "")
                                      }
                                      onChange={requestLeaveForm.handleChange}
                                      value={requestLeaveForm.values.LeaveCount}
                                      placeholder="Leave Count"
                                    />
                                  </div>
                                  {isLeaveCount && (
                                    <div className="invalid-feedback">
                                      <p>* Only allowed decimal value 0.5</p>{" "}
                                    </div>
                                  )}
                                  <div className="invalid-feedback">
                                    {requestLeaveForm.errors.LeaveCount &&
                                      requestLeaveForm.touched.LeaveCount
                                      ? requestLeaveForm.errors.LeaveCount
                                      : null}
                                  </div>
                                </div>
                              </div>
                            )}
                            {requestLeaveForm.values.LeaveCount?.toString()
                              ?.length > 0 && (
                                <div className="mb-4 col-md-12">
                                  <div className="innerform-grp">
                                    <label className="form-label">Comment</label>
                                    <div className="cover-form">
                                      <input
                                        type="text"
                                        // className="form-control"
                                        name="comment"
                                        className={
                                          "form-control" +
                                          (requestLeaveForm.errors.comment &&
                                            requestLeaveForm.touched.comment
                                            ? " is-invalid"
                                            : "")
                                        }
                                        onChange={requestLeaveForm.handleChange}
                                        value={requestLeaveForm.values.comment}
                                      />
                                    </div>
                                    <div className="invalid-feedback">
                                      {requestLeaveForm.errors.comment &&
                                        requestLeaveForm.touched.comment
                                        ? requestLeaveForm.errors.comment
                                        : null}
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="btns-grp text-right">
                                <button
                                  type="submit"
                                  className="savebtn-click m-0"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4">
                    <div className="side-add-section pl-0">
                      <div className="card right-div">
                        <div className="card-body">
                          <div className="text-center">
                            <h4 className="how-it mb-4">{howItWorkHeader}</h4>
                            <img
                              src="images/org-img/leave/leave_adjustment.svg"
                              style={{ width: "70%" }}
                            />

                            <ul className="ul-work text-dark text-left mt-4">
                              <li>
                                <i className="fa fa-check-square-o"></i>
                                {howItWorkText}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default LeaveAdjustment;
